export const placeholderWithFormattersPattern = '([a-z0-9_.[\\]:/+>-]|(&gt;)){1,}(\\|[a-z_]+)*';
export const singlePlaceholderRegExp = new RegExp('^\\${' + placeholderWithFormattersPattern + '}$', 'i');
export const placeholderWithFormattersRegExp = new RegExp('\\${' + placeholderWithFormattersPattern + '}', 'gi');
export const hasPlaceholderWithFormattersRegExp = new RegExp('\\${' + placeholderWithFormattersPattern + '}', 'i');
export function hasPlaceholder(value) {
  return hasPlaceholderWithFormattersRegExp.test(value || '');
}
//# sourceMappingURL=regexps.js.map